/** Non-green palette for read-only / active collaborators in the editor header. */
export const ACTIVE_PRESENCE_AVATAR_COLORS = [
  '#395f97',
  '#f26545',
  '#7c3aed',
  '#db2777',
  '#4f46e5',
  '#d97706',
  '#e11d48',
  '#0284c7',
  '#9333ea',
  '#c026d3',
  '#2563eb',
  '#ea580c'
] as const;

/** Reserved for users with unsaved edits — never used in the active palette. */
export const EDITING_PRESENCE_AVATAR_COLOR = '#2e9e5b';

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getActivePresenceAvatarColor(userId: string): string {
  const key = userId.trim().toLowerCase();
  if (!key) return ACTIVE_PRESENCE_AVATAR_COLORS[0];
  const index = hashString(key) % ACTIVE_PRESENCE_AVATAR_COLORS.length;
  return ACTIVE_PRESENCE_AVATAR_COLORS[index];
}
